var React = require('react');

function CommentSingleColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.09591 0.463799C1.40424 0.463799 0.831787 1.03567 0.831787 1.72666V9.44606C0.831787 10.137 1.40422 10.7102 2.09591 10.7102H3.14341V13.1547C3.14341 13.3431 3.24953 13.5152 3.41809 13.6C3.58602 13.6848 3.78765 13.668 3.93934 13.5564L7.80289 10.7101H15.5487C16.2404 10.7101 16.8128 10.137 16.8128 9.44601V1.72661C16.8128 1.03563 16.2404 0.463745 15.5487 0.463745L2.09591 0.463799Z","fill":"#AFB4BD"}));
}

CommentSingleColor.defaultProps = {"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none"};

module.exports = CommentSingleColor;

CommentSingleColor.default = CommentSingleColor;
